export default {
    zh: {
        serialNo: '单据编号',
        AddDebitInfo: "新增扣账信息",
        createReport: "新增调查报告",
        feedbackDetail: "问题报告详情",
        finalDebitInfo: "最终扣账信息",
        feedbackNo: "问题报告单据编号",
        feedbackStatus: "反馈单状态",
        reportNo: "调查报告单据编号",
        reportStatus: "调查报告状态",
        reportType: "调查报告类型",
        haveQuestion: "是否发起疑问反馈",
        questionStatus: "疑问反馈状态",
        supplierCostTime: "供应商调查花费时间",
        remark: "备注",
        fcQuestionRemarks: "FC疑问备注",
        fcAnnex: "FC疑问附件",
        receiveDate: "接到反馈日期",
        deadline: "初次最晚提交时间",
        haveRejected: "是否被CQS退回过",
        sampleHandleMethod: "留样处理",
        needDebit: "是否扣账",
        debitUnit: "扣账数量单位",
        problemLevel: "投诉问题类别",
        canContinue: "能否继续使用",
        responsibleParty: "责任方",
        basicInfo: "基本信息",
        reportDetail: "详细调查报告",
        treatment: "改进措施",
        supplierAnalysis: "调查分析简报（供应商）",
        CQSAnalysis: "调查分析简报（质量反馈中心）",
        FBCAnalysis: "调查分析简报（McD）",
        sign: "麦中供应链QS批准",
        description: "描述",
        attachment: "附件",
        DocAttachment: "文件附件",
        PicAttachment: "图片附件",
        selectImg: '选择图片',
        debitNumber: "扣账数量",
        pleaseFillInRejectReason: "请填写拒绝原因",
        pleaseReason: "请填写原因",
        auditPass: '审批通过',
        auditReject: '审批驳回',
        questionOfStore: '门店疑问',
        answerOfFBC: '疑问回复',
        answerStatus: '反馈状态',
        sendCQS: '发送CQS',
        uploadFile: '请上传附件',
        doubtCommunication: '疑问沟通',
        haveInterrogativeCommunication: '是否发起疑问沟通',
        doubtCommunicationStatus: '疑问沟通状态',
        storeTime: '门店花费时间(小时)',
        fbcOperateTime: '质量反馈中心调查花费时间(小时)',
        mcdOperateTime: 'CQS处理问题花费时间(小时)',
        isaAswerStatus: '反馈是否处理',
        NoCQSAnalysis: "调查分析简报（质量反馈中心）不能为空",
        ModifyReason: '修改原因',
        AlreadyFinalReport: '已经创建过最终报告，不能创建新调查报告',
        AlreadySuspend: '已经中止，不能创建新调查报告',
        yes: "已处理",
        no: "待处理",
        PleaseMonth: "请选择月份",
        NoDetailLines: "没有明细行",
        debitNumNoempty: "扣账数量不能为空",
        pleaseSelectPublishReports: "请选择下发的调查报告",
        publishAnalysis: "调查分析结论",
        pleaseInputAnlisys: "请填写调查分析结论",
        byEmail: "本系统疑问沟通时效性为5天，之后如有需要，请您邮件联系质量反馈中心feedback.center@cn.mcd.com",
        existsQuestion: "调查报告{0}已发起疑问沟通，不能重复发起。",
        debitsExport: "扣账信息报表导出",
        completeVersionPDF:'导出PDF',
        lightVersionPDF:'简易版PDF',
        publish: '发布',
        publishUser: '发布人',
        publishDate: '发布日期',
        box:'箱'
    },
    en: {
        AddDebitInfo: "Add deduction information",
        createReport: "Create Report",
        feedbackDetail: "Store Feedback Order Detail",
        finalDebitInfo: "Final Debit Info",
        feedbackNo: "Feedback No",
        feedbackStatus: "Feedback Status",
        reportNo: "Report No",
        reportStatus: 'Report Status',
        reportType: "Report Type",
        haveQuestion: "Have Question",
        questionStatus: "Question Status",
        supplierCostTime: "Supplier Cost Time",
        remark: "notes",
        fcQuestionRemarks: "FC question remarks",
        fcAnnex: "FC question attachment",
        receiveDate: "Receive Date",
        deadline: "Deadline",
        haveRejected: "Have Rejected",
        sampleHandleMethod: "Sample Handle Method",
        needDebit: "Need Debit",
        debitUnit: "Debit Unit",
        problemLevel: "Problem Level",
        canContinue: "Can Continue",
        responsibleParty: "Responsible Party",
        debitNumber: "Debit Number",
        basicInfo: "Basic Info",
        reportDetail: "Report Detail",
        treatment: "Treatment",
        supplierAnalysis: "Supplier Analysis",
        CQSAnalysis: "CQS Analysis",
        FBCAnalysis: "MCD Analysis",
        sign: "Auditor Sign",
        description: "Description",
        attachment: "Attachment",
        DocAttachment: "Document attachment",
        PicAttachment: "Picture attachment",
        selectImg: 'select picture',
        pleaseFillInRejectReason: "Please Fill In Reject Reason",
        pleaseReason: "Please Reason",
        auditPass: 'Audit Pass',
        auditReject: 'Audit Reject',
        questionOfStore: 'Question of Store',
        answerOfFBC: 'Answer of Feedback Center',
        answerStatus: 'Answer Status',
        sendCQS: 'Send CQS',
        uploadFile: 'Please upload the attachment',
        doubtCommunication: 'Interrogative communication',
        haveInterrogativeCommunication: 'Whether to initiate question communication',
        doubtCommunicationStatus: 'Interrogative communication Status',
        storeTime: 'Store time(hours)',
        fbcOperateTime: 'Feedback center survey time (hours)',
        mcdOperateTime: 'CQS processing time (hours)',
        isaAswerStatus: 'Whether the feedback is handled',
        NoCQSAnalysis: "Survey analysis briefing (feedback Center) cannot be empty",
        ModifyReason: 'Modify Reason',
        AlreadyFinalReport: 'The final report has already been created, cannot create a new survey report',
        AlreadySuspend: 'Unable to create a new survey report because it has been aborted',
        yes: "Processed",
        no: "Pending disposal",
        PleaseMonth: "Please select a month",
        NoDetailLines: "No detail lines",
        debitNumNoempty: "Deduction quantity cannot be empty",
        byEmail: "The validity of this system is 5 days. Please contact the quality feedback center by email feedback.center@cn.mcd.com if you need",
        existsQuestion: "The investigation report {0} has initiated the question communication. It cannot be initiated repeatedly.",
        debitsExport: "Debit Export",
        publishAnalysis: "Publish Analysis",
        completeVersionPDF:'Export PDF',
        pleaseSelectPublishReports: "Please select publish reports",
        lightVersionPDF:'Light version PDF',
        publish: 'Publish',
        box:'BOX'
    }
}
